import { FlowComponent } from '../../../flow.min.js';
import styles from './styles.js';

const template = FlowComponent.html`
    <div id="loader-wrapper" class="fixed inset-0 flex items-center justify-center bg-white z-50 transition-opacity duration-300">
        <div class="flex flex-col items-center">
            <!-- Spinner -->
            <svg class="animate-spin h-10 w-10 text-brilliant-azure-500 mb-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            <h2 class="text-gray-600 font-medium text-sm font-roboto" id="loader-message">${'message'}</h2>
        </div>
    </div>
`;

export class FlowLoading extends FlowComponent {
    static get styles() { return styles; }
    static get template() { return template; }

    onMount() {
        super.onMount();
        this.#applyVariant();
        
        // Default message
        const msgEl = this.root.getElementById('loader-message');
        if (msgEl && !this.getAttribute('message')) {
            msgEl.textContent = 'Cargando...';
        }
    }

    #applyVariant() {
        const variant = this.getAttribute('variant');
        const wrapper = this.root.getElementById('loader-wrapper');
        
        if (variant === 'overlay') {
            wrapper.classList.remove('fixed', 'z-50', 'bg-white');
            wrapper.classList.add('absolute', 'z-20', 'bg-white/70', 'backdrop-blur-[1px]');
        }
    }
}

customElements.define('flow-loading', FlowLoading);
